export default __webpack_public_path__ + "static/media/tefft.c89d4e44.jpg";